import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { InspectionDBService } from '../db/inspection-db-service';
import { InspectionWithResultsDto } from '@core/api';

@Injectable()
export class InspectionResolver implements Resolve<InspectionWithResultsDto> {
  private inspectionDbService = inject(InspectionDBService);

  public resolve(route: ActivatedRouteSnapshot) {
    return this.inspectionDbService.getInspectionWithResults(route.paramMap.get('inspectionKey')!);
  }
}
